import { render, staticRenderFns } from "./AddSizeSidebar.vue?vue&type=template&id=4b32db56&scoped=true&"
import script from "./AddSizeSidebar.vue?vue&type=script&lang=js&"
export * from "./AddSizeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddSizeSidebar.vue?vue&type=style&index=0&id=4b32db56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32db56",
  null
  
)

export default component.exports